import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../../../shared/context/auth-context";
import { ClinicaContext } from "../../../../../../shared/context/clinica-context";
import "../List.scss";

//mui - manter os componentes da tabela
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
//lucide-react para ícones
import { Trash2, ClipboardCheck, Eye, Edit3 } from "lucide-react";
//date-fns para substituir moment
import { format } from "date-fns";
//Antd
import { Popover } from "antd";
import { Popconfirm } from "antd";

import { abreviarNome } from "../../../../../../shared/util/helperFunctions";
import { useLoading } from "../../../../../../shared/context/LoadingContext";
import BadgeUnidade from "../../../../../../shared/components/badgeUnidade/BadgeUnidade";
import { podeAlterarRegisto } from "../../../../../../shared/util/unidadeRegisto";

function ListPlanoTratamento({
  data,
  handleOpenModal,
  handleDesativar,
  handleOpenModalVerPlano,
}) {
  const { startLoading, stopLoading } = useLoading();
  const clinica = useContext(ClinicaContext);
  const [planosTratamento, setPlanosTratamento] = useState(data);
  const auth = useContext(AuthContext);
  useEffect(() => {
    setPlanosTratamento(data);
  }, [data]);

  const hasSessions = (planoTratamento) => {
    // Check if any procedimento has sessions
    const hasSessions = planoTratamento.procedimentos.some(
      (procedimento) => procedimento.sessoes && procedimento.sessoes.length > 0
    );

    // Return true only if there are sessions
    return hasSessions;
  };

  const renderOptions = (row) => {
    let content = [
      <span
        className="popOverMenu--option"
        onClick={exportarPlanoTratamentoExcel.bind(null, row)}
        key={row._id}
      >
        Gerar Excel
      </span>,
    ];

    const isMedicoAutorizado =
      (auth.role === "Médico/Administrador" || auth.role === "Dentista") &&
      row.medico_responsavel._id === auth.userId;

    const isSecretariaOuAssistenteAutorizado =
      (auth.role === "Secretária(o)" || auth.role === "Assistente") &&
      auth.usuariosAssociados.some(
        (medico) => medico.id === row.medico_responsavel.id
      );

    const podeExcluir =
      // Um plano de outra unidade é só de leitura: desativá-lo mexe no
      // orçamento que lhe deu origem, e esse é de lá.
      podeAlterarRegisto(row.estabelecimento, auth) &&
      !row.plano_completo &&
      !row.data_inicio &&
      row.canDelete &&
      hasSessions(row) === false &&
      row.status !== "INTERROMPIDO" &&
      auth.perm.includes("d-plt") &&
      (isMedicoAutorizado || isSecretariaOuAssistenteAutorizado);

    if (podeExcluir) {
      content.push(
        <Popconfirm
          title="Desativação de plano de tratamento"
          description="Tem a certeza que pretende desativar o plano de tratamento?"
          icon={<Trash2 style={{ color: "red" }} />}
          okText="Sim"
          cancelText="Não"
          onConfirm={() => handleDesativar(row.id)}
        >
          <div className="popOverMenu--option">
            <span>Desativar</span>
            <Trash2 className="popOverMenu--option__icon" />
          </div>
        </Popconfirm>
      );
    }

    return content || null;
  };

  const exportarPlanoTratamentoExcel = async (planoTratamento) => {
    try {
      startLoading();

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/exportarExcel/${clinica.clinica._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({ planoId: planoTratamento._id }),
        }
      );

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `PlanoTratamento_${planoTratamento.numero}-${planoTratamento.cliente.nome}.xlsx`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erro ao exportar:", error);
    } finally {
      stopLoading();
    }
  };
  return (
    <>
      <TableContainer component={Paper} className="table">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead style={{ background: "#fff" }}>
            <TableRow>
              {/* <TableCell className="tableCell tableCell--heading tableCell--heading--start">
                Histórico
              </TableCell> */}

              <TableCell className="tableCell tableCell--heading tableCell--heading--start">
                Código
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Médico Responsável
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Data Criação
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Data Inicio
              </TableCell>
              <TableCell className="tableCell tableCell--heading">
                Data Fim
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Estado
              </TableCell>

              <TableCell className="tableCell tableCell--heading tableCell--heading--end">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>

          {planosTratamento && (
            <TableBody>
              {planosTratamento.map((row, index) => (
                <TableRow key={row._id}>
                  <TableCell className="tableCell">
                    {"PL" +
                      row.numero +
                      "_OR" +
                      row.orcamento.codigo +
                      "_" +
                      +format(new Date(row.created_at), "yyyy")}
                    {/* Sem selo de "só consulta": um plano de outra unidade
                        PODE ser executado aqui — só não pode ser desativado. A
                        pastilha diz a que unidade pertence, e chega. */}
                    <BadgeUnidade estabelecimento={row.estabelecimento} />
                  </TableCell>

                  <TableCell className="tableCell">
                    {abreviarNome(row.medico_responsavel.name)}
                  </TableCell>

                  <TableCell className="tableCell">
                    {format(new Date(row.created_at), "dd/MM/yyyy")}
                  </TableCell>

                  <TableCell className="tableCell">
                    {row.data_inicio ? row.data_inicio : ""}
                  </TableCell>

                  <TableCell className="tableCell">
                    {row.data_fim ? row.data_fim : ""}
                  </TableCell>

                  <TableCell className="tableCell">
                    <span
                      className={
                        row.status
                          ? "status " + row.status
                          : row.plano_completo
                          ? "status concluido"
                          : row.canDelete && hasSessions(row) === false
                          ? "status pendente"
                          : "status transformado"
                      }
                    >
                      {row.status === "INTERROMPIDO"
                        ? "Interrompido"
                        : row.plano_completo
                        ? "Concluido"
                        : row.canDelete && hasSessions(row) === false
                        ? "Criado"
                        : "Em Andamento"}
                    </span>
                  </TableCell>
                  <TableCell className="tableCell">
                    <div className="tableCell__action">
                      {(auth.role === "Médico/Administrador" ||
                        auth.role === "Dentista") &&
                        row.status !== "INTERROMPIDO" && (
                          <Tooltip
                            title={!row.plano_completo ? "Executar" : "Editar"}
                          >
                            {!row.plano_completo ? (
                              <ClipboardCheck
                                className="icon__list"
                                onClick={handleOpenModal.bind(null, row.id)}
                              />
                            ) : (
                              <Edit3
                                className="icon__list"
                                onClick={handleOpenModal.bind(null, row.id)}
                              />
                            )}
                          </Tooltip>
                        )}

                      {auth.perm.includes("r-plt") &&
                        (row.status === "INTERROMPIDO" ? (
                          <Tooltip title="Ver Plano de Tratamento">
                            <Eye
                              className="icon__list"
                              onClick={handleOpenModalVerPlano.bind(
                                null,
                                row.id,
                                "interrompido"
                              )}
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Ver Plano de Tratamento">
                            <Eye
                              className="icon__list"
                              onClick={handleOpenModalVerPlano.bind(
                                null,
                                row.id,
                                "normal"
                              )}
                            />
                          </Tooltip>
                        ))}

                      {renderOptions(row) && (
                        <Popover
                          content={renderOptions(row)}
                          trigger="click"
                          placement="bottom"
                        >
                          <div className="dots__menu">
                            <div className="dot"></div>
                            <div className="dot"></div>
                            <div className="dot"></div>
                          </div>
                        </Popover>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </>
  );
}

export default ListPlanoTratamento;
